// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPlanDto } from './IPlanDto';
import {
    IPlanDtoFromJSON,
    IPlanDtoFromJSONTyped,
    IPlanDtoToJSON,
    IPlanDtoToJSONTyped,
} from './IPlanDto';
import type { IReportHeader } from './IReportHeader';
import {
    IReportHeaderFromJSON,
    IReportHeaderFromJSONTyped,
    IReportHeaderToJSON,
    IReportHeaderToJSONTyped,
} from './IReportHeader';
import type { IReportSummaryDtoParticipantAccountActivitySummaryRecordDto } from './IReportSummaryDtoParticipantAccountActivitySummaryRecordDto';
import {
    IReportSummaryDtoParticipantAccountActivitySummaryRecordDtoFromJSON,
    IReportSummaryDtoParticipantAccountActivitySummaryRecordDtoFromJSONTyped,
    IReportSummaryDtoParticipantAccountActivitySummaryRecordDtoToJSON,
    IReportSummaryDtoParticipantAccountActivitySummaryRecordDtoToJSONTyped,
} from './IReportSummaryDtoParticipantAccountActivitySummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto
 */
export interface IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto {
    /**
     * 
     * @type {Array<IReportHeader>}
     * @memberof IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto
     */
    headers?: Array<IReportHeader>;
    /**
     * 
     * @type {Array<IPlanDto>}
     * @memberof IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto
     */
    plans?: Array<IPlanDto>;
    /**
     * 
     * @type {Date}
     * @memberof IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto
     */
    last_updated_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto
     */
    date_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto
     */
    date_to?: Date;
    /**
     * 
     * @type {IReportSummaryDtoParticipantAccountActivitySummaryRecordDto}
     * @memberof IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto
     */
    content?: IReportSummaryDtoParticipantAccountActivitySummaryRecordDto;
    /**
     * 
     * @type {number}
     * @memberof IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto
     */
    total_records?: number;
    /**
     * 
     * @type {number}
     * @memberof IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto
     */
    page_number?: number;
    /**
     * 
     * @type {number}
     * @memberof IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto
     */
    page_size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto
     */
    has_next?: boolean;
}

/**
 * Check if a given object implements the IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto interface.
 */
export function instanceOfIReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto(value: object): value is IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto {
    return true;
}

export function IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDtoFromJSON(json: any): IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto {
    return IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'headers': json['headers'] == null ? undefined : ((json['headers'] as Array<any>).map(IReportHeaderFromJSON)),
        'plans': json['plans'] == null ? undefined : ((json['plans'] as Array<any>).map(IPlanDtoFromJSON)),
        'last_updated_at': json['last_updated_at'] == null ? undefined : (new Date(json['last_updated_at'])),
        'date_from': json['date_from'] == null ? undefined : (new Date(json['date_from'])),
        'date_to': json['date_to'] == null ? undefined : (new Date(json['date_to'])),
        'content': json['content'] == null ? undefined : IReportSummaryDtoParticipantAccountActivitySummaryRecordDtoFromJSON(json['content']),
        'total_records': json['total_records'] == null ? undefined : json['total_records'],
        'page_number': json['page_number'] == null ? undefined : json['page_number'],
        'page_size': json['page_size'] == null ? undefined : json['page_size'],
        'has_next': json['has_next'] == null ? undefined : json['has_next'],
    };
}

export function IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDtoToJSON(json: any): IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto {
    return IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDtoToJSONTyped(value?: IReportSummaryPageDtoParticipantAccountActivitySummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'headers': value['headers'] == null ? undefined : ((value['headers'] as Array<any>).map(IReportHeaderToJSON)),
        'plans': value['plans'] == null ? undefined : ((value['plans'] as Array<any>).map(IPlanDtoToJSON)),
        'last_updated_at': value['last_updated_at'] == null ? undefined : ((value['last_updated_at']).toISOString()),
        'date_from': value['date_from'] == null ? undefined : ((value['date_from']).toISOString().substring(0,10)),
        'date_to': value['date_to'] == null ? undefined : ((value['date_to']).toISOString().substring(0,10)),
        'content': IReportSummaryDtoParticipantAccountActivitySummaryRecordDtoToJSON(value['content']),
        'total_records': value['total_records'],
        'page_number': value['page_number'],
        'page_size': value['page_size'],
        'has_next': value['has_next'],
    };
}

